/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendIndustryItemDto } from '../../models/backend-industry-item-dto';

export interface ListIndustriesIndustriesGet$Params {
  /**
   * Опциональный фильтр по `locale` (ru / en / ...)
   */
  locale?: string | null;
}

export function listIndustriesIndustriesGet(
  http: HttpClient,
  rootUrl: string,
  params?: ListIndustriesIndustriesGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendIndustryItemDto>>> {
  const rb = new RequestBuilder(rootUrl, listIndustriesIndustriesGet.PATH, 'get');
  if (params) {
    rb.query('locale', params.locale, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendIndustryItemDto>>;
    }),
  );
}

listIndustriesIndustriesGet.PATH = '/industries';
